import { render } from "./TableSpecification.vue?vue&type=template&id=6e12600c&scoped=true"
import script from "./TableSpecification.vue?vue&type=script&lang=js"
export * from "./TableSpecification.vue?vue&type=script&lang=js"

import "./TableSpecification.vue?vue&type=style&index=0&id=6e12600c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e12600c"]])

export default __exports__